export const heroBlockFragment = gql`
  fragment HeroBlockFragment on HeroBlockRecord {
    ... on HeroBlockRecord {
      label
      title
      subtitle
      items {
        ... on SingleLineTextBlockRecord {
          text
        }
      }
      image {
        ...ImageFragment
      }
    }
  }
`

export const sectionFragment = gql`
  ${heroBlockFragment}

  fragment SectionFragment on PerformanceLandingPageSectionRecord {
    # id and name is just used for debugging purposes
    id
    name
    contentBlocks {
      __typename
      ...HeroBlockFragment
      ... on FaqBlockRecord {
        title
        text
        linkText
        questions {
          ... on FaqQuestionBlockRecord {
            question
            answer
          }
        }
      }
      ... on HowItWorksBlockRecord {
        title
        image {
          ...ImageFragment
        }
        steps {
          ... on ImageTextItemBlockRecord {
            image {
              ...ImageFragment
            }
            text
          }
        }
      }
      ... on LandingPageTestimonialsBlockRecord {
        title
        testimonials {
          ... on LandingPageTestimonialBlockRecord {
            image {
              ...ImageFragment
            }
            author
            testimonial
          }
        }
      }
      ... on PromotionBlockRecord {
        title
        image {
          ...ImageFragment
        }
        description
        listDescription
        features {
          ... on SingleLineTextBlockRecord {
            text
          }
        }
      }
      ... on MealPlansBlockRecord {
        label
        title
        subtitle
        description
        mealPlans {
          ... on MealPlansItemBlockRecord {
            image {
              ...ImageFragment
            }
            text
            link
          }
        }
      }
      ... on HighlightedFeaturesBlockRecord {
        title
        features {
          ... on ImageHeadingTextBlockRecord {
            text
            heading
            image {
              ...ImageFragment
            }
          }
        }
      }
      ... on FeaturesBlockRecord {
        title
        features {
          ... on MultiLineTextBlockRecord {
            text
          }
        }
      }
      ... on ReviewsBlockRecord {
        title
        reviews {
          text
        }
      }
      ... on ScienceBlockRecord {
        title
        features {
          ... on ImageHeadingTextBlockRecord {
            text
            heading
            image {
              ...ImageFragment
            }
          }
        }
        referencesLinkText
      }
    }
  }
`

export const imageFragment = gql`
  fragment ImageFragment on FileField {
    responsiveImage(imgixParams: { auto: format }) {
      src
      bgColor
      width
      height
    }
  }
`

const query = gql`
  ${sectionFragment}

  ${imageFragment}

  query PerformanceLandingPage($slug: String!, $language: SiteLocale!) {
    performanceLandingPage(filter: { slug: { eq: $slug } }, locale: $language) {
      _locales
      seo {
        description
        title
      }
      _seoMetaTags {
        attributes
        content
      }
      downloadLinkText
      signupLinkText
      downloadLinkFirst
      sections {
        ...SectionFragment
      }
    }
  }
`

export default query
